import React, {createContext, useReducer} from 'react';
import {MapReducer} from "../reducers/MapReducer";

export const MapContext = createContext();

export const initialState = {
    inProgress: false,
    divisionData: null,
    dockyardData: null,
    config: {
        center: [1.9102478, 47.9018006],
        zoom: {
            current: process.env.REACT_APP_MAP_ZOOM_CURRENT || 15,
            minZoom: process.env.REACT_APP_MAP_ZOOM_MIN || 13,
            maxZoom: process.env.REACT_APP_MAP_ZOOM_MAX || 21,
        },
        geolocate: {
            active: parseInt(process.env.REACT_APP_MAP_GEOLOCATE_DEFAULT_ACTIVE) === 1 || false,
        },
        layerSwitcherPanel: {
            open: false,
            layers : {}
        }
    }
};

const MapContextProvider = props => {
    const [mapContext, dispatch] = useReducer(MapReducer, initialState, () => {
        return initialState
    });

    return (
        <MapContext.Provider value={{mapContext, dispatch}}>
            {props.children}
        </MapContext.Provider>
    )
};

export default MapContextProvider;